import { Injectable } from '@angular/core';
import { ConnectRestService } from 'src/app/services/connect-rest.service'

@Injectable({
  providedIn: 'root'
})
export class DataStoreService {
  finalResponse: any;
  ocbcDataStore: any;
  adobeAnalyticInit: boolean = false;
  flowStep: String = '';
  aaURl = ''

  constructor( private connect : ConnectRestService ) {
  }

  saveFinalResponse(response) {
    this.finalResponse = response;
  }

  setAAData(pageName) {
    setTimeout(() => {
      console.log('setTimeOutTest', typeof window['_satellite'])
      if (typeof window['_satellite'] === 'undefined') {
        this.setAAData(pageName);
      } else {
        this.setAADataStorage(pageName);
      }
    }, 2000);
  }

  async setAADataStorage(pageName) {
    var caseID = sessionStorage['ServiceHeader'] && JSON.parse(sessionStorage['ServiceHeader'])['CaseID'] ? JSON.parse(sessionStorage['ServiceHeader'])['CaseID'] : '';
    var companyInfo = await this.getCompanyInfo(); 
    var pageName2 = this.getPageName2(pageName);
    this.ocbcDataStore = {
      page: {
        pageName: "my:ocbc:business:smes:accounts:" + sessionStorage.ProductDescription.toLowerCase() + ":" + pageName2, 
        language: sessionStorage.language, //Page Language
        pageCategory: "pre-login application page",
        channel: "accounts",
        country: "my",
        lob: "ocbc business banking"
      },
      product: {
        productid: sessionStorage.currentProduct.toLowerCase(),
        productCategory: "accounts",
        productSubCategory: sessionStorage.currentProduct.toLowerCase() !== 'u9' ? "myr" : '',
        productType: "smes",
        productName: sessionStorage.ProductDescription.toLowerCase()
      },
      user: {
        CIF: "", //should be passed post login OCBC specific encrypted ID, if CIF value is not there pass blank
        loginStatus: "pre-login", //<<pre-login/secure>>
        authType: "non-authenticated" //<<authenticated/non-authenticated>>
      },
      event: {
        pageView: "true"
      }
    };

    if (pageName === 'start' || pageName === 'tell-us' || pageName === 'identify-your-company') {
      this.ocbcDataStore['application'] = {
        applicationId: "", // CaseID after R0015
        flowStep: this.flowStep, // page name
        myInfoStatus: "", // 
        flowType: "account application form",
        journeyName: "",
        subJourneyName: "",
        applicationStatus: "" // new before company confirm, pending, submitted after qr code
      };
    } else if (pageName === 'company-details-info' || pageName === 'signature' || pageName === 'company-constitution' || pageName === 'declaration' || pageName === 'thank-you-application' || pageName === 'last-step') {
      this.ocbcDataStore['application'] = {
        applicationId: caseID,
        flowStep: this.flowStep,
        myInfoStatus: "",
        flowType: "account application form",
        companyType: companyInfo['type'],
        companyName: "",
        journeyName: "obao flow",
        subJourneyName: companyInfo['flow'],
        applicationStatus: pageName === 'thank-you-application' ? 'pending' : '',
        transactionId: pageName === 'thank-you-application' ? JSON.parse(sessionStorage.FinalResponse)['ReferenceNumber'] : '', //pass the reference code in transactionId
        applicationRetrieveStatus: sessionStorage['resumePage'] && sessionStorage['resumePage'] === pageName ? 'rcomplete' : ''
      }
    }
    
    window['ocbcData'] = this.ocbcDataStore;
    try{window['_satellite'].track('pageView');}catch(i) {}
  }

  getCompanyInfo() {
    var companyDetails = sessionStorage['ConnectedParties'] && JSON.parse(sessionStorage['ConnectedParties'])['CompanyDetails'] ? JSON.parse(sessionStorage['ConnectedParties'])['CompanyDetails'] : undefined;
    if (companyDetails) {
      return { 
        name: companyDetails['BusinessName'] ? companyDetails['BusinessName'].toLowerCase() : '',
        type: companyDetails['Constitution'] ? companyDetails['Constitution'].toLowerCase() : '',
        flow: companyDetails['ConnectedParties'] ? companyDetails['ConnectedParties'].length > 1 ? 'via 2mc' : 'via 1mc' : ''
      };
    }
    return { name: '', type: '', flow: ''}
  }

  async setAdobeAnalytics() {
    var data = {Property: 'aa_properties'}
    var status = false;
    try{
      var responseData = await this.connect.connectRest(data, 'R0700', '');
      if(responseData.Status == "Success"){
        sessionStorage.setItem('AAStatus', responseData['status'].toString());
        sessionStorage.setItem('AAURL', responseData['url']);
        if (responseData['status']) {
          var jq = document.createElement('script');
          jq.src = responseData['url'];
          jq.async = true;
          document.body.appendChild(jq);
          status = responseData['status'];
        }
      }else{
      }
    } catch(ex){
      this.connect.displayErrorMessage(ex)
    }
    return status;
  }

  getFinalResponse() {
    return this.finalResponse;
  }

  getAAData() {
    return this.ocbcDataStore;
  }

  async getAAStatus() { 
    var status;
    if (!this.adobeAnalyticInit) {
      status = await this.setAdobeAnalytics();
      this.adobeAnalyticInit = true;
    } else {
      status = sessionStorage.AAStatus === 'true';
    }
    return status;
  }

  getPageName2(pageName) { //pageName === 'tell-us' || 'identify-your-company' 'company-details-info' || 'signature' || 'company-constitution' || 'declaration' || 'thank-you-application'
    switch (pageName) {
      case 'start':
        return 'application landing';
      case 'tell-us': 
        return 'contact details';
      case 'identify-your-company': 
        return 'identify your company';
      case 'company-details-info':
        this.flowStep = 'journey start'; 
        return 'company details';
      case 'signature': 
        this.flowStep = 'step8';
        return 'upload signature';
      case 'company-constitution': 
        this.flowStep = 'step9';
        return 'company constitution and board resolution';
      case 'declaration': 
        this.flowStep = 'step10';
        return 'declaration and agreement';
      case 'thank-you-application':
        this.flowStep = 'journey complete';
        return 'one more step';
      case 'last-step':
        this.flowStep = '';
        return 'application review by other director';
      default:
        break;
    }
  }

}
